import { Navigate } from "react-router-dom";

// Authentication
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import ForgotPassword from "pages/Authentication/ForgotPassword";

// Dashboard
import Crm from "pages/Dashboard/Crm";

// Settings
import Settings from "pages/Settings/Settings";

// Datamaster
import Jabatan from "pages/Datamaster/Jabatan";
import Sertifikasi from "pages/Datamaster/Sertifikasi";
import Religion from "pages/Datamaster/Religion";
import Blood from "pages/Datamaster/Blood";
import Educations from "pages/Datamaster/Educations";
import Family from "pages/Datamaster/Family";
import Projects from "pages/Datamaster/Projects";
import Questions from "pages/Datamaster/Questions";
import JobPosting from "pages/Datamaster/JobPosting";

// Developer
import Development from "pages/Development/Development";
import Modules from "pages/Development/Modules";
import Apis from "pages/Development/Apis";

// Transactions
import Feedback from "pages/Transactions/Feedback";
import Applicant from "pages/Transactions/Applicant";

// Qualification
import Kualifikasi from "pages/Qualification/FormQualification";

// Logs
import Logs from "pages/Logs/Logs";

const authProtectedRoutes = [
    // Dashboard
    { path: "/dashboard", name: "Dashboard", component: <Crm /> },

    // Settings
    { path: "/settings", name: "Settings", component: <Settings /> },
    
    // Datamaster
    { path: "/job-position", name: "JobPosition", component: <Jabatan /> },
    { path: "/sertifikasi", name: "Sertifikasi", component: <Sertifikasi /> },
    { path: "/religion", name: "Religion", component: <Religion /> },
    { path: "/blood", name: "Blood", component: <Blood /> },
    { path: "/education", name: "Education", component: <Educations /> },
    { path: "/family", name: "Family", component: <Family /> },
    { path: "/project", name: "Project", component: <Projects /> },
    { path: "/questions", name: "Questions", component: <Questions /> },
    { path: "/job-posting", name: "JobPosting", component: <JobPosting /> },

    // Developer
    { path: "/development/migrations", name: "Migrations", component: <Development /> },
    { path: "/development/modules", name: "Modules", component: <Modules /> },
    { path: "/development/apis", name: "APIs Documentation", component: <Apis /> },


    // Transactions
    { path: "/transactions/feedback", name: "Feedback", component: <Feedback /> },
    { path: "/transactions/job-applicants", name: "Applicant", component: <Applicant /> },

    // Logs
    { path: "/logs", name: "Logs", component: <Logs /> },
];

const publicRoutes = [
    // Authentication
    { path: "/", name: "Root", component: <Login /> },
    { path: "/login", name: "Login", component: <Login /> },
    { path: "/logout", name: "Logout", component: <Logout /> },
    { path: "/forgot-password", name: "ForgotPassword", component: <ForgotPassword /> },
    { path: "/qualification", name: "Qualification", component: <Kualifikasi /> },
];

export { authProtectedRoutes, publicRoutes };